/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState, Dispatch } from "react";
import { ReportStatus } from "~/generated/graphql";
import { PopoverControls } from "~/components";
import { DeleteModal } from "./DeleteModal";

type Props = {
  status: ReportStatus;
  id: string;
  url?: string | null;
  name: string;
  setHighlightedReportId?: Dispatch<string | undefined>;
};

export function Actions({
  status,
  id,
  url,
  name,
  setHighlightedReportId,
}: Props) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDownload = () => {
    if (url) {
      window.open(url, "_blank");
    }
    setHighlightedReportId?.(undefined);
  };

  const handleDelete = () => {
    setHighlightedReportId?.(undefined);
    setIsDeleteModalOpen(true);
  };

  const preparePopoverItems = (): Array<{
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }> => {
    switch (status) {
      case ReportStatus.Completed:
        return [
          {
            label: `Download Report`,
            onClick: handleDownload,
            disabled: !url,
          },
          {
            label: `Delete Report`,
            onClick: handleDelete,
          },
        ];
      case ReportStatus.Failed:
        return [
          {
            label: `Delete Report`,
            onClick: handleDelete,
          },
        ];
      case ReportStatus.InProgress:
        return [
          {
            label: `Download Report`,
            onClick: handleDownload,
            disabled: true,
          },
        ];
      default:
        return [];
    }
  };
  const items = preparePopoverItems();
  const hasNoItems = items.length === 0;

  return (
    <>
      <PopoverControls disabled={hasNoItems} size={"small"} items={items} />
      <DeleteModal
        reportId={id}
        reportName={name}
        isDeleteModalOpen={isDeleteModalOpen}
        close={() => setIsDeleteModalOpen(false)}
      />
    </>
  );
}
